import {
  LOADER, LOADER_MAIN_APP,
} from "../actions/types";

const initialState = {
  loadingState: false,
  refresh: false,
  pullToRefreshIndicator: false,
  footerIndicator: false,
  loadingMainApp: false,
};

export const LoaderReducer = (state = initialState, action:any) => {
  const oldState = {...state};
  const {type, payload} = action;
  switch (type) {
    case LOADER:
      return {
        ...oldState,
        loadingState: payload,
      };
      case LOADER_MAIN_APP:
        return {
          ...oldState,
          loadingMainApp: payload,
        };
  }
  return oldState;
};
